import { useQuery } from '@apollo/client/react';
import { useRouter } from 'next/router';

import { CandidateDocument, CandidateQuery } from '@pflegia/data-access/candidate.generated';
import { useAuth } from '@pflegia/ui/contexts/auth.context';

import { useCollectInfoModal } from '@domains/job-board/components/collect-info-modal/useCollectInfoModal';
import { shouldShowLowPriorityModal } from '@domains/login/components/should-show-low-priority-modal';
import { shouldShowPhoneNumberModal } from '@domains/login/components/should-show-phone-number-modal';

import { MAINTENANCE } from '@shared/application/constants';

import { isWithinWaOptInSession } from './wa-opt-in-throttle';

export const useWaOptInEligibility = (): {
  candidate: CandidateQuery['candidate'] | undefined;
  isEligible: boolean;
} => {
  const authenticated = useAuth();
  const { asPath, pathname } = useRouter();
  const { data, loading } = useQuery(CandidateDocument, { skip: !authenticated || pathname === MAINTENANCE });
  const { showModal: isCollectInfoModalEligible } = useCollectInfoModal();

  const candidate = data?.candidate;

  const isEligible = (() => {
    if (!authenticated || loading || !candidate) return false;
    if (!candidate.isWhatsAppOptInPromptAllowed) return false;
    if (isCollectInfoModalEligible) return false;
    if (shouldShowLowPriorityModal(candidate)) return false;
    if (shouldShowPhoneNumberModal(candidate, asPath)) return false;
    if (isWithinWaOptInSession()) return false;
    return true;
  })();

  return { candidate, isEligible };
};
